function postMessage(type, val = {}) {
  window.parent.postMessage(
    {
      type,
      val
    },
    '*'
  )
}
export default postMessage
